import { ContainerModule } from 'inversify';
import { TYPES } from '../types';
import { DomainConfig } from './DomainConfig';

export const domainModule = new ContainerModule(({ bind }) => {
  bind(TYPES.DomainConfig).to(DomainConfig).inSingletonScope();
});
